var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinChatIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3 21 9l-3.5 1.5-4 4 .5 4.5-6-6L3 21l4-6-6-6 4.5.5 4-4L11 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinChatIndicator);
export default __webpack_public_path__ + "static/media/pinChatIndicator.ef3a98add97b5b6dfc76be5202be5008.svg";
export { ForwardRef as ReactComponent };